
//スクロールした時に処理を実行
window.addEventListener('scroll', function(){
	//トップへ戻るボタンを取得
	let CTAbtn = document.querySelector('.cta-button');
  
	//画面上部からトップビジュアル下の位置取得
	const FV = document.querySelector('.FV').getBoundingClientRect().bottom;
  
	//トップビジュアル下の位置より下にスクロールされたらactiveクラウを付与
	if(FV <= 0){
	  CTAbtn.classList.add('active');
	} else {
	  //スクロールが200px未満のときactiveクラスを外す
	  CTAbtn.classList.remove('active');
	}

	//ドキュメントの高さ
	const scrollHeight = document.body.clientHeight;

	//スクロール位置
	const scrollPosition = window.pageYOffset;
	
	//windowの高さ
	const windowHeignt = window.innerHeight;
	
	//footer取得
	const footer = document.querySelector('.lp-footer');
	  
	//footerの高さ
	const footerHeight = footer.offsetHeight;
	if(scrollHeight - scrollPosition - windowHeignt <= footerHeight){
		CTAbtn.classList.add('stop');
	} else {
		CTAbtn.classList.remove('stop');
	}
	
  });

